export default "__VITE_ASSET__64566c98__"